import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  Typography, Box, Divider, Chip, Grid, Link,
} from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ImageIcon from '@material-ui/icons/Image';
import {
  FloodIcon,
  DroughtTimelineIcon,
  NounWaterQualityIcon,
} from '../../../../assets/svg/Icon';
import PdfIcon from '../../../../assets/images/event/pdf-icon.png';
import DownloadIcon from '../../../../assets/images/event/download-icon.png';

// const useStyles = makeStyles((theme) => ({
//   eventTitle: {
//     fontSize: '1rem',
//     fontWeight: 400,
//     fontFamily: 'Kanit, sans-serif',
//   },
//   eventDesc: {
//     fontSize: '0.9rem',
//   },
//   statusDot: {
//     marginLeft: theme.spacing(2),
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: 6,
//     fontSize: '0.75rem',
//     fontWeight: 500,
//     whiteSpace: 'nowrap',
//     '&::before': {
//       content: '""',
//       width: 4,
//       height: 4,
//       borderRadius: '50%',
//       backgroundColor: 'currentColor',
//     },
//   },

// }));

const HeaderEvent = ({
  event, statusColorMap, classes = {}, md = null,
}) => {
  // const classes = useStyles();
  if (!event) return null;

  // ใช้ไอคอนตามประเภทเหตุการณ์
  const getEventIcon = (eventTypeId) => {
    switch (eventTypeId) {
      case 1:
        return <FloodIcon style={{ fontSize: '50px' }} />;
      case 2:
        return <DroughtTimelineIcon style={{ fontSize: '50px' }} />;
      case 3:
        return <NounWaterQualityIcon style={{ fontSize: '50px' }} />;
      default:
        return <FloodIcon style={{ fontSize: '50px' }} />;
    }
  };

  const getFileType = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();

    if (ext === 'pdf') return 'pdf';

    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
      return 'image';
    }

    return 'other';
  };
  const html = md?.render(event.description || '');
  return (
    <Box
      display="block"
      alignItems="center"
      justifyContent="space-between"
      mb={1}
      p={2}
    >
      {/* ===== LEFT GROUP ===== */}
      <Box display="flex" alignItems="center" gap={1.5}>
        {/* ICON (BIG) */}
        <Box display="flex" alignItems="center">
          {getEventIcon(event?.event_type?.id)}
        </Box>

        {/* TITLE + DATE */}
        <Box ml={2}>
          <Typography variant="h6" className={classes.eventTitle}>
            {event.event_name}
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{ fontSize: 13, color: 'text.secondary' }}
          >
            <Typography variant="caption" display="block" gutterBottom>
              <CalendarTodayIcon fontSize="inherit" />
              {' '}
              {event.created_at
                ? moment(event.created_at).format('D MMM YYYY')
                : '-'}
            </Typography>
            <Typography
              variant="caption"
              display="block"
              gutterBottom
              className={classes.statusDot}
              style={{ color: statusColorMap?.[event.status] || '#6b7280' }}
            >
              {event.status_name?.name || '-'}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider style={{ margin: '16px 0' }} />

      {html && (
        <>
          <Box
            mt={2}
            className={classes.eventDesc}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </>
      )}

      <Divider style={{ margin: '16px 0' }} />

      {((event.areas || []).length > 0 || (event.tags || []).length > 0) && (
        <Box mt={2}>
          <Grid container spacing={3}>
            {/* ===== LEFT : 3 columns ===== */}
            <Grid item xs={12} md={3}>
              {(event.areas || []).length > 0 && (
                <>
                  <Typography variant="subtitle2" gutterBottom>
                    พื้นที่ที่ได้รับผลกระทบ
                  </Typography>

                  <ul style={{
                    marginTop: 6, marginLeft: 10, paddingLeft: 18, fontSize: '0.8rem',
                  }}
                  >
                    {event.areas.map((a) => (
                      <li key={a.id}>{a.label}</li>
                    ))}
                  </ul>
                </>
              )}
            </Grid>
            <Grid item xs={12} md>
              {(event.tags || []).length > 0 && (
                <Box display="flex">
                  <Typography variant="subtitle2" color="textPrimary" gutterBottom>
                    แท็ก
                  </Typography>

                  <Box display="flex" flexWrap="wrap" ml={2}>
                    {event.tags.map((tag) => (
                      <Chip
                        key={tag.id}
                        label={tag.name}
                        size="small"
                        style={{
                          backgroundColor: '#E0E0E0',
                          color: '#000',
                          fontWeight: 400,
                          marginRight: 10,
                          marginBottom: 10,
                          fontSize: 12,
                          padding: '2px 10px',
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle2" className={classes.tagLabel} gutterBottom>
                ไฟล์แนบ
              </Typography>
              {/* ===== PDF ก่อน ===== */}
              {(event.attachments || [])
                .filter((file) => getFileType(file.file_name) === 'pdf')
                .map((file) => (
                  <Link
                    key={file.id}
                    href={file.full_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.attachmentItem}
                    underline="none"
                  >
                    <Box className={classes.attachmentLeft}>
                      <img
                        src={PdfIcon}
                        alt="PDF"
                        style={{ width: 20, marginLeft: 3 }}
                      />
                      <Typography className={classes.attachmentName}>
                        {file.file_name}
                      </Typography>
                    </Box>

                    <img src={DownloadIcon} alt="Download" style={{ width: 20 }} />
                  </Link>
                ))}

              {/* ===== IMAGE ต่อ ===== */}
              {(event.attachments || [])
                .filter((file) => getFileType(file.file_name) === 'image')
                .map((file) => (
                  <Link
                    key={file.id}
                    href={file.full_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.attachmentItem}
                    underline="none"
                  >
                    <Box className={classes.attachmentLeft}>
                      <ImageIcon className={classes.iconImage} />
                      <Typography className={classes.attachmentName}>
                        {file.file_name}
                      </Typography>
                    </Box>

                    <img src={DownloadIcon} alt="Download" style={{ width: 20 }} />
                  </Link>
                ))}
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

/* ✅ PropTypes */
HeaderEvent.propTypes = {
  event: PropTypes.shape({
    event_name: PropTypes.string,
    created_at: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status_name: PropTypes.shape({
      name: PropTypes.string,
    }),
    event_type: PropTypes.shape({
      id: PropTypes.number,
    }),
    areas: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string,
      }),
    ),
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
      }),
    ),
    attachments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        event_id: PropTypes.number.isRequired,
        file_path: PropTypes.string.isRequired,
        file_name: PropTypes.string.isRequired,
        file_type: PropTypes.string,
        file_size: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        description: PropTypes.string,
        full_url: PropTypes.string,
        created_at: PropTypes.string,
        updated_at: PropTypes.string,
      }),
    ),
  }),
  classes: PropTypes.shape({
    reportCard: PropTypes.string,
    eventTitle: PropTypes.string,
    metaRow: PropTypes.string,
    eventDate: PropTypes.string,
    statusDot: PropTypes.string,
    markdown: PropTypes.string,
    tagLabel: PropTypes.string,
    tagChip: PropTypes.string,
    attachmentItem: PropTypes.string,
    attachmentLeft: PropTypes.string,
    attachmentName: PropTypes.string,
    iconImage: PropTypes.string,
  }),
  statusColorMap: PropTypes.shape({
    public: PropTypes.string,
  }),
  md: PropTypes.shape({
    render: PropTypes.func.isRequired,
  }),
};
HeaderEvent.defaultProps = {
  event: null,
  statusColorMap: {
    public: '#10b981',
  },
  classes: {},
  md: null,
};
export default HeaderEvent;
